(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tm-avis-bandeau"] && !Shopify.designMode) return;
  try {
    
  /* Carrousel partagé des sections « modèle v2 » (avis + conception).
     Défilement natif au doigt, points de position générés d'après les cartes. */
  if (!customElements.get('tm2-slider')) {
    customElements.define(
      'tm2-slider',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-tm2-track]');
          if (!this.track) return;
          this.slides = Array.prototype.slice.call(this.track.querySelectorAll('[data-tm2-slide]'));
          this.dotsBox = this.querySelector('[data-tm2-dots]');
          this.reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
          this.onScroll = this.onScroll.bind(this);
          this.onSelect = this.onSelect.bind(this);
          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          document.addEventListener('shopify:block:select', this.onSelect);
          this.buildDots();
          this.update();
        }

        disconnectedCallback() {
          document.removeEventListener('shopify:block:select', this.onSelect);
        }

        // Un point par carte ; aucun point s'il n'y a qu'une carte.
        buildDots() {
          if (!this.dotsBox) return;
          this.dotsBox.textContent = '';
          if (this.slides.length === 1) return;
          var self = this;
          this.slides.forEach(function (slide, i) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'tm2-dot';
            dot.setAttribute('aria-label', 'Afficher l’élément ' + (i + 1) + ' sur ' + self.slides.length);
            dot.addEventListener('click', function () {
              self.goTo(i);
            });
            self.dotsBox.appendChild(dot);
          });
        }

        // Carte la plus proche du centre (mode centré) ou du bord gauche.
        index() {
          var track = this.track;
          var max = track.scrollWidth - track.clientWidth;
          if (!this.isCenter() && track.scrollLeft >= max - 2) return this.slides.length - 1;
          var box = track.getBoundingClientRect();
          var padLeft = parseFloat(window.getComputedStyle(track).paddingLeft) || 0;
          var center = this.isCenter();
          var ref = center ? box.left + box.width / 2 : box.left + padLeft;
          var best = 0;
          var bestDist = Infinity;
          for (var i = 0; i !== this.slides.length; i++) {
            var r = this.slides[i].getBoundingClientRect();
            var pos = center ? r.left + r.width / 2 : r.left;
            var dist = Math.abs(pos - ref);
            if (bestDist > dist) {
              bestDist = dist;
              best = i;
            }
          }
          return best;
        }

        // L'alignement vient du CSS (scroll-snap-align) : il peut changer selon la largeur d'écran.
        isCenter() {
          var first = this.slides[0];
          if (!first) return false;
          return (window.getComputedStyle(first).scrollSnapAlign || '').indexOf('center') !== -1;
        }

        goTo(i) {
          var slide = this.slides[i];
          if (!slide) return;
          var track = this.track;
          var padLeft = parseFloat(window.getComputedStyle(track).paddingLeft) || 0;
          var left = this.isCenter()
            ? slide.offsetLeft + slide.offsetWidth / 2 - track.clientWidth / 2
            : slide.offsetLeft - padLeft;
          track.scrollTo({ left: Math.max(0, left), behavior: this.reduce ? 'auto' : 'smooth' });
        }

        onScroll() {
          if (this.raf) return;
          var self = this;
          this.raf = requestAnimationFrame(function () {
            self.raf = 0;
            self.update();
          });
        }

        update() {
          if (!this.dotsBox) return;
          var cur = this.index();
          var dots = this.dotsBox.children;
          for (var d = 0; d !== dots.length; d++) {
            dots[d].setAttribute('aria-current', d === cur ? 'true' : 'false');
          }
        }

        // Éditeur Shopify : cliquer un bloc amène sa carte à l'écran.
        onSelect(event) {
          var i = this.slides.indexOf(event.target);
          if (i !== -1) this.goTo(i);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tm-collage"] && !Shopify.designMode) return;
  try {
    
  /* Puces du carrousel de photos (téléphone / tablette).
     Le point actif suit la carte affichée ; un clic sur un point amène la carte correspondante. */
  (function () {
    function padStart(el) {
      var st = getComputedStyle(el);
      return parseFloat(st.paddingInlineStart || st.paddingLeft) || 0;
    }

    function setup(root) {
      var stack = root.querySelector('.tm-collage__stack');
      var dotsBox = root.querySelector('.tm-collage__dots');
      if (!stack || !dotsBox || stack.tmCollageDotsReady) return;
      stack.tmCollageDotsReady = true;

      var cards = Array.prototype.slice.call(root.querySelectorAll('.tm-collage__img'));
      var dots = Array.prototype.slice.call(dotsBox.querySelectorAll('.tm-collage__dot'));

      function target(card) {
        return card.offsetLeft - padStart(stack);
      }

      function paint() {
        var best = 0;
        var min = Infinity;
        cards.forEach(function (card, i) {
          var gap = Math.abs(target(card) - stack.scrollLeft);
          if (min > gap) {
            min = gap;
            best = i;
          }
        });
        dots.forEach(function (dot, i) {
          dot.setAttribute('aria-current', i === best ? 'true' : 'false');
        });
      }

      var ticking = false;
      stack.addEventListener(
        'scroll',
        function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            ticking = false;
            paint();
          });
        },
        { passive: true }
      );

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          var card = cards[i];
          if (!card) return;
          var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          stack.scrollTo({ left: target(card), behavior: reduce ? 'auto' : 'smooth' });
        });
      });

      paint();
    }

    function init(scope) {
      var roots = (scope || document).querySelectorAll('.tm-collage--notes');
      Array.prototype.slice.call(roots).forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init();
      });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tm-compare"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.tm-cmp__wrap').forEach(function (wrap) {
    var range = wrap.querySelector('.tm-cmp__range');
    if (!range) return;
    var update = function () { wrap.style.setProperty('--pos', range.value + '%'); };
    range.addEventListener('input', update);
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tm-conception"] && !Shopify.designMode) return;
  try {
    
  /* Carrousel partagé des sections « modèle v2 » : même code que dans
     tm-avis-bandeau (déclaré une seule fois, grâce au test ci-dessous). */
  if (!customElements.get('tm2-slider')) {
    customElements.define(
      'tm2-slider',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-tm2-track]');
          if (!this.track) return;
          this.slides = Array.prototype.slice.call(this.track.querySelectorAll('[data-tm2-slide]'));
          this.dotsBox = this.querySelector('[data-tm2-dots]');
          this.reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
          this.onScroll = this.onScroll.bind(this);
          this.onSelect = this.onSelect.bind(this);
          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          document.addEventListener('shopify:block:select', this.onSelect);
          this.buildDots();
          this.update();
        }

        disconnectedCallback() {
          document.removeEventListener('shopify:block:select', this.onSelect);
        }

        buildDots() {
          if (!this.dotsBox) return;
          this.dotsBox.textContent = '';
          if (this.slides.length === 1) return;
          var self = this;
          this.slides.forEach(function (slide, i) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'tm2-dot';
            dot.setAttribute('aria-label', 'Afficher l’élément ' + (i + 1) + ' sur ' + self.slides.length);
            dot.addEventListener('click', function () {
              self.goTo(i);
            });
            self.dotsBox.appendChild(dot);
          });
        }

        index() {
          var track = this.track;
          var max = track.scrollWidth - track.clientWidth;
          if (!this.isCenter() && track.scrollLeft >= max - 2) return this.slides.length - 1;
          var box = track.getBoundingClientRect();
          var padLeft = parseFloat(window.getComputedStyle(track).paddingLeft) || 0;
          var center = this.isCenter();
          var ref = center ? box.left + box.width / 2 : box.left + padLeft;
          var best = 0;
          var bestDist = Infinity;
          for (var i = 0; i !== this.slides.length; i++) {
            var r = this.slides[i].getBoundingClientRect();
            var pos = center ? r.left + r.width / 2 : r.left;
            var dist = Math.abs(pos - ref);
            if (bestDist > dist) {
              bestDist = dist;
              best = i;
            }
          }
          return best;
        }

        // L'alignement vient du CSS (scroll-snap-align) : il peut changer selon la largeur d'écran.
        isCenter() {
          var first = this.slides[0];
          if (!first) return false;
          return (window.getComputedStyle(first).scrollSnapAlign || '').indexOf('center') !== -1;
        }

        goTo(i) {
          var slide = this.slides[i];
          if (!slide) return;
          var track = this.track;
          var padLeft = parseFloat(window.getComputedStyle(track).paddingLeft) || 0;
          var left = this.isCenter()
            ? slide.offsetLeft + slide.offsetWidth / 2 - track.clientWidth / 2
            : slide.offsetLeft - padLeft;
          track.scrollTo({ left: Math.max(0, left), behavior: this.reduce ? 'auto' : 'smooth' });
        }

        onScroll() {
          if (this.raf) return;
          var self = this;
          this.raf = requestAnimationFrame(function () {
            self.raf = 0;
            self.update();
          });
        }

        update() {
          if (!this.dotsBox) return;
          var cur = this.index();
          var dots = this.dotsBox.children;
          for (var d = 0; d !== dots.length; d++) {
            dots[d].setAttribute('aria-current', d === cur ? 'true' : 'false');
          }
        }

        onSelect(event) {
          var i = this.slides.indexOf(event.target);
          if (i !== -1) this.goTo(i);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tm-garantie-rembourse"] && !Shopify.designMode) return;
  try {
    
  /* Remontée vers l'offre, partagée par les sections « modèle v2 »
     (bouton de garantie + barre « Retour à l'offre »). Déclarée une seule fois.
     mode « kit » : sélecteur de kit (tm-pack) ; mode « top » : haut de la fiche produit. */
  if (!window.tm2ScrollToOffer) {
    window.tm2ScrollToOffer = function (mode) {
      var target = null;
      if (mode === 'kit') {
        target = document.querySelector('.tm-pack:not(.tm-pack--setup)') || document.querySelector('[data-tm-pack-atc]');
      }
      if (!target) {
        target =
          document.querySelector('.shopify-section[id$="__main"]') ||
          document.querySelector('product-information, .product-information');
      }
      var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      var behavior = reduce ? 'auto' : 'smooth';
      if (!target) {
        window.scrollTo({ top: 0, behavior: behavior });
        return;
      }
      // Laisse la place à l'en-tête collant du thème pour ne pas cacher le haut de l'offre.
      var header = document.querySelector('header-component, #header-component, .header');
      var offset = (header ? header.offsetHeight : 0) + (mode === 'kit' ? 12 : 0);
      var y = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: Math.max(0, y), behavior: behavior });
    };
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-tm2-offer]');
      if (!trigger) return;
      event.preventDefault();
      window.tm2ScrollToOffer(trigger.getAttribute('data-tm2-offer'));
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tm-gif-carrousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tm-gif-carousel')) {
    customElements.define(
      'tm-gif-carousel',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-tm-gc-track]');
          if (!this.track) return;
          this.cards = Array.prototype.slice.call(this.track.querySelectorAll('[data-tm-gc-card]'));
          this.dotsBox = this.querySelector('[data-tm-gc-dots]');
          this.prevBtn = this.querySelector('[data-tm-gc-prev]');
          this.nextBtn = this.querySelector('[data-tm-gc-next]');
          this.positions = 0;

          // Mouvement réduit demandé par le téléphone : aucun clip ne démarre seul.
          var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.reduce = reduce;
          this.autoplay = this.dataset.autoplay !== 'false' && !reduce;

          this.onScroll = this.onScroll.bind(this);
          this.layout = this.layout.bind(this);
          this.onBlockSelect = this.onBlockSelect.bind(this);

          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.goTo(this.current() - 1));
          if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.goTo(this.current() + 1));
          if (this.dotsBox) {
            this.dotsBox.addEventListener('click', (e) => {
              var dot = e.target.closest('.tm-gc__dot');
              if (dot) this.goTo(parseInt(dot.dataset.i, 10) || 0);
            });
          }

          // Recalcule les points quand la largeur change (rotation, redimensionnement).
          if ('ResizeObserver' in window) {
            this.ro = new ResizeObserver(() => requestAnimationFrame(this.layout));
            this.ro.observe(this.track);
          } else {
            window.addEventListener('resize', this.layout);
          }

          this.setupVideos();
          document.addEventListener('shopify:block:select', this.onBlockSelect);
          this.layout();
        }

        disconnectedCallback() {
          if (this.ro) this.ro.disconnect();
          if (this.io) this.io.disconnect();
          window.removeEventListener('resize', this.layout);
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
        }

        // Distance entre deux cartes (largeur d'une carte + espace).
        step() {
          if (this.cards.length > 1) return this.cards[1].offsetLeft - this.cards[0].offsetLeft || 1;
          return this.track.clientWidth || 1;
        }

        maxScroll() {
          return Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        }

        // Nombre de positions = crans de défilement possibles + 1.
        layout() {
          var max = this.maxScroll();
          var n = max > 2 ? Math.ceil((max - 2) / this.step()) + 1 : 1;
          if (n !== this.positions && this.dotsBox) {
            this.positions = n;
            this.dotsBox.textContent = '';
            for (var i = 0; i !== n; i++) {
              var dot = document.createElement('button');
              dot.type = 'button';
              dot.className = 'tm-gc__dot';
              dot.dataset.i = String(i);
              dot.setAttribute('aria-label', 'Aller à la position ' + (i + 1) + ' sur ' + n);
              this.dotsBox.appendChild(dot);
            }
          }
          this.positions = n;
          this.classList.toggle('is-static', n === 1);
          this.update();
        }

        current() {
          if (this.positions === 1) return 0;
          if (this.track.scrollLeft >= this.maxScroll() - 2) return this.positions - 1;
          var i = Math.round(this.track.scrollLeft / this.step());
          return Math.max(0, Math.min(this.positions - 1, i));
        }

        goTo(i) {
          var idx = Math.max(0, Math.min(this.positions - 1, i));
          var left = Math.min(idx * this.step(), this.maxScroll());
          this.track.scrollTo({ left: left, behavior: this.reduce ? 'auto' : 'smooth' });
        }

        onScroll() {
          if (this.raf) return;
          this.raf = requestAnimationFrame(() => {
            this.raf = 0;
            this.update();
          });
        }

        // Met à jour le point actif et grise la flèche en bout de course.
        update() {
          var cur = this.current();
          if (this.dotsBox) {
            var dots = this.dotsBox.children;
            for (var d = 0; d !== dots.length; d++) {
              dots[d].setAttribute('aria-current', d === cur ? 'true' : 'false');
            }
          }
          if (this.prevBtn) this.prevBtn.disabled = cur === 0;
          if (this.nextBtn) this.nextBtn.disabled = cur === this.positions - 1;
        }

        // Clips vidéo : lecture muette en boucle quand la carte est à moitié visible,
        // pause dès qu'elle sort de l'écran (économise la batterie et les données).
        setupVideos() {
          this.videos = this.cards
            .map(function (c) { return c.querySelector('video'); })
            .filter(Boolean);
          if (!this.videos.length) return;

          this.videos.forEach((v) => {
            var card = v.closest('[data-tm-gc-card]');
            v.muted = true;
            v.setAttribute('muted', '');
            v.addEventListener('play', function () { card.classList.remove('is-paused'); });
            if (!this.autoplay) card.classList.add('is-paused');
          });

          // Toucher un clip = pause / reprise.
          this.track.addEventListener('click', (e) => {
            var card = e.target.closest('[data-tm-gc-card]');
            var v = card && card.querySelector('video');
            if (!v) return;
            if (v.paused) {
              delete v.dataset.userPaused;
              this.play(v);
            } else {
              v.pause();
              v.dataset.userPaused = '1';
              card.classList.add('is-paused');
            }
          });

          if (!this.autoplay || !('IntersectionObserver' in window)) return;
          this.io = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                var v = entry.target;
                if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
                  if (!v.dataset.userPaused) this.play(v);
                } else if (!v.paused) {
                  v.pause();
                }
              });
            },
            { threshold: [0, 0.5, 1] }
          );
          this.videos.forEach((v) => this.io.observe(v));
        }

        play(v) {
          if (v.preload === 'none') v.preload = 'auto';
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        }

        // Éditeur Shopify : sélectionner un bloc fait défiler jusqu'à sa carte.
        onBlockSelect(e) {
          if (!this.contains(e.target)) return;
          var idx = this.cards.indexOf(e.target.closest('[data-tm-gc-card]'));
          if (idx === -1) return;
          this.track.scrollTo({ left: Math.min(this.cards[idx].offsetLeft - this.cards[0].offsetLeft, this.maxScroll()) });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tm-livraison-badges"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(n) { return String(n).padStart(2, '0'); }

    function addBusinessDays(base, days) {
      var d = new Date(base.getTime());
      var added = 0;
      while (added < days) {
        d.setDate(d.getDate() + 1);
        var dow = d.getDay();
        if (dow !== 0 && dow !== 6) added++;
      }
      return d;
    }

    function formatFr(d) {
      return d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long' });
    }

    function parisNow() {
      var fmt = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Europe/Paris', hour12: false,
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit'
      });
      var parts = {};
      fmt.formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
      return new Date(parts.year + '-' + parts.month + '-' + parts.day + 'T' + parts.hour + ':' + parts.minute + ':' + parts.second);
    }

    function initTmLb(root) {
      var cutoffHour = parseInt(root.getAttribute('data-cutoff-hour'), 10);
      var minDays = parseInt(root.getAttribute('data-min-days'), 10);
      var maxDays = parseInt(root.getAttribute('data-max-days'), 10);
      var deliveryEl = root.querySelector('[data-tm-lb-delivery]');
      var timerEl = root.querySelector('[data-tm-lb-timer]');
      var labelEl = root.querySelector('[data-tm-lb-cutoff-label]');

      if (deliveryEl && !isNaN(minDays) && !isNaN(maxDays)) {
        var today = new Date();
        var lo = addBusinessDays(today, minDays);
        var hi = addBusinessDays(today, maxDays);
        deliveryEl.textContent = 'entre le ' + formatFr(lo) + ' et le ' + formatFr(hi);
      }

      if (timerEl && labelEl && !isNaN(cutoffHour)) {
        var tick = function () {
          var now = parisNow();
          var target = new Date(now.getTime());
          target.setHours(cutoffHour, 0, 0, 0);
          var isToday = target > now;
          if (!isToday) target.setDate(target.getDate() + 1);

          labelEl.textContent = isToday
            ? 'Commandé avant ' + cutoffHour + 'h : expédié aujourd’hui, encore'
            : 'Commandé avant ' + cutoffHour + 'h demain : expédié demain, encore';

          var diff = Math.max(0, target - now);
          var h = Math.floor(diff / 3600000);
          var m = Math.floor((diff % 3600000) / 60000);
          var sec = Math.floor((diff % 60000) / 1000);
          timerEl.textContent = (h > 0 ? h + 'h ' : '') + pad(m) + 'min ' + pad(sec) + 's';
        };
        tick();
        setInterval(tick, 1000);
      }
    }

    document.querySelectorAll('[data-tm-lb]').forEach(initTmLb);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tm-retour-offre"] && !Shopify.designMode) return;
  try {
    
  /* Barre « Retour à l'offre » + bouton « haut de page » (sections « modèle v2 »). */
  if (!customElements.get('tm2-retour-offre')) {
    customElements.define(
      'tm2-retour-offre',
      class extends HTMLElement {
        connectedCallback() {
          this.go = this.querySelector('[data-tm2-ro-go]');
          this.top = this.querySelector('[data-tm2-ro-top]');
          this.mode = this.dataset.target === 'kit' ? 'kit' : 'top';
          this.reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
          this.onScroll = this.onScroll.bind(this);
          this.onGo = this.onGo.bind(this);
          this.onTop = this.onTop.bind(this);
          if (this.go) this.go.addEventListener('click', this.onGo);
          if (this.top) this.top.addEventListener('click', this.onTop);
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onScroll, { passive: true });
          this.onScroll();
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.onScroll);
          window.removeEventListener('resize', this.onScroll);
        }

        // Zone « offre » = la section principale de la fiche produit (galerie + kit).
        offerZone() {
          return (
            document.querySelector('.shopify-section[id$="__main"]') ||
            document.querySelector('product-information, .product-information')
          );
        }

        onScroll() {
          if (this.raf) return;
          var self = this;
          this.raf = requestAnimationFrame(function () {
            self.raf = 0;
            self.update();
          });
        }

        update() {
          var zone = this.offerZone();
          // La barre s'affiche quand toute la zone de l'offre est passée au-dessus de l'écran.
          var passed = zone ? 0 >= zone.getBoundingClientRect().bottom : window.pageYOffset > window.innerHeight;
          this.classList.toggle('is-bar', !!this.go && passed);
          this.classList.toggle('is-top', window.pageYOffset > window.innerHeight);
        }

        onGo() {
          if (window.tm2ScrollToOffer) {
            window.tm2ScrollToOffer(this.mode);
            return;
          }
          // Repli si la section « Garantie remboursement » n'est pas sur la page.
          var zone = this.offerZone();
          var y = zone ? zone.getBoundingClientRect().top + window.pageYOffset : 0;
          window.scrollTo({ top: Math.max(0, y), behavior: this.reduce ? 'auto' : 'smooth' });
        }

        onTop() {
          window.scrollTo({ top: 0, behavior: this.reduce ? 'auto' : 'smooth' });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tm-video-avis"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tm-vf]').forEach(function (root) {
    if (root.dataset.tmVfReady) return;
    root.dataset.tmVfReady = '1';

    var track = root.querySelector('[data-tm-vf-track]');
    if (!track) return;
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-tm-vf-card]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-tm-vf-dot]'));
    var prev = root.querySelector('[data-tm-vf-prev]');
    var next = root.querySelector('[data-tm-vf-next]');
    if (!cards.length) return;

    function stepSize() {
      if (cards.length < 2) return track.clientWidth;
      return cards[1].offsetLeft - cards[0].offsetLeft;
    }

    function nearest() {
      var best = 0;
      var bestDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var d = Math.abs(cards[i].offsetLeft - track.scrollLeft);
        if (d < bestDist) { bestDist = d; best = i; }
      }
      return best;
    }

    function setActive(i) {
      for (var d = 0; d < dots.length; d++) {
        dots[d].setAttribute('aria-selected', d === i ? 'true' : 'false');
      }
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= cards.length - 1;
    }

    function goTo(i) {
      var clamped = Math.max(0, Math.min(cards.length - 1, i));
      track.scrollTo({ left: cards[clamped].offsetLeft, behavior: 'smooth' });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.getAttribute('data-i'), 10) || 0);
      });
    });
    if (prev) prev.addEventListener('click', function () { goTo(nearest() - 1); });
    if (next) next.addEventListener('click', function () { goTo(nearest() + 1); });

    var raf = false;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = true;
      requestAnimationFrame(function () {
        raf = false;
        setActive(nearest());
      });
    });

    // Lecture : bouton play -> la vidéo de sa carte démarre avec le son,
    // les autres se coupent. Une carte qui sort de vue se met en pause.
    root.querySelectorAll('[data-tm-vf-play]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = btn.closest('[data-tm-vf-card]');
        var vid = card && card.querySelector('video');
        if (!vid) return;
        cards.forEach(function (c) {
          var v = c.querySelector('video');
          if (v && v !== vid) { v.pause(); c.classList.remove('is-playing'); }
        });
        vid.muted = false;
        vid.controls = true;
        card.classList.add('is-playing');
        var p = vid.play();
        if (p && p.catch) { p.catch(function () {}); }
      });
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) return;
          var v = e.target.querySelector('video');
          if (v && !v.paused) { v.pause(); }
        });
      }, { root: track, threshold: 0.4 });
      cards.forEach(function (c) { io.observe(c); });
    }

    setActive(0);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tm-video-comparaison"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tm-vc] .tm-vc__video').forEach(function (video) {
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var p = video.play();
            if (p && p.catch) { p.catch(function () {}); }
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.25 });
      io.observe(video);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
